"use client";

import { CategoryChips } from "@/composites/category";

import type { AlsoDiscoverContent } from "./read-also-discover";

export function AlsoDiscover({
	heading,
	links
}: AlsoDiscoverContent): JSX.Element | null {
	return <CategoryChips heading={heading} links={links} />;
}
